// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__21A7U","rootSmall":"AddTileButton_rootSmall__2I7zu"};